import { Link } from 'react-router-dom';

export function Unauthorized() {
  return (
    <div style={{ padding: 40, textAlign: 'center' }}>
      <h1>401</h1>
      <p>You are not authorized to view this page.</p>
      <Link to="/login">Login</Link>
    </div>
  );
}
